import { type ReactNode, memo } from 'react';
import type { ConfigObject } from '../_configs/types';
import type { FaarenListCar } from '../_tools/types/faaren';
import { type FacetsService } from '../_types/Car';
import { AllFaarenVehiclesProvider } from '../context/all-faaren-vehicles';
import { AllFacetsProvider } from '../context/all-facets';
import { ModuleSkeletonProvider } from '../context/module-skeleton';
import { RootContainerProvider } from '../context/root-container';
import { SettingsProvider } from '../context/settings';
import type { Modules } from '../modules/_definition/types';

type CommonProviderProps = {
    allFaarenVehicles: FaarenListCar[];
    children: ReactNode;
    module: Modules;
    rawAllFacets: FacetsService;
    rootContainer: HTMLDivElement;
    settings: ConfigObject;
    Skeleton: ReactNode;
    SkeletonDetails: ReactNode;
};

function CommonProvider(props: CommonProviderProps) {
    const { allFaarenVehicles, children, module, rootContainer, rawAllFacets, settings, Skeleton, SkeletonDetails } = props;

    return (
        <ModuleSkeletonProvider initDetailsSkeleton={SkeletonDetails} initModuleSkeleton={Skeleton}>
            <SettingsProvider initSettings={settings} module={module} rootContainer={rootContainer}>
                <RootContainerProvider initRootContainer={rootContainer}>
                    <AllFacetsProvider rawAllFacets={rawAllFacets}>
                        <AllFaarenVehiclesProvider initAllFaarenVehicles={allFaarenVehicles}>{children}</AllFaarenVehiclesProvider>
                    </AllFacetsProvider>
                </RootContainerProvider>
            </SettingsProvider>
        </ModuleSkeletonProvider>
    );
}

export default memo(CommonProvider);
